<template>
  <div class="tt-settings-nav">
    <router-link
      v-for="tab in visibleTabs"
      :key="tab.to"
      :to="tab.to"
      :exact="!!tab.exact"
      class="tt-settings-tab"
      active-class="active"
      exact-active-class="active"
    >
      <i class="bi" :class="tab.icon"></i>
      {{ tab.label }}
    </router-link>
  </div>
</template>

<script>
import { canAccess } from "@/middlewares/auth";

const TABS = [
  { to: "/trips/settings", label: "Office Origin", icon: "bi-building", permission: "trip_settings", exact: true },
  { to: "/trips/settings/vehicles", label: "Vehicles", icon: "bi-car-front", permission: "trip_vehicles" },
  { to: "/trips/settings/drivers", label: "Drivers", icon: "bi-person-badge", permission: "trip_drivers" },
  { to: "/trips/settings/destinations", label: "Destinations", icon: "bi-geo-alt", permission: "trip_destinations" },
];

export default {
  name: "TripSettingsNav",
  computed: {
    role() {
      return (this.$store.state.user || {}).role;
    },
    visibleTabs() {
      return TABS.filter((t) => canAccess(t.permission, this.role));
    },
  },
};
</script>
